import Remedio from '@/views/public/remedios'
import Unidades from '@/views/public/remedios/Unidades'
import DetalheUnidade from '@/views/public/remedios/DetalheUnidade'
import { DEFAULT_TITLE } from '../const'

export const remedios = [
  {
    name: 'remedio',
    path: '/remedio-facil',
    component: Remedio,
    meta: {
      title: `${DEFAULT_TITLE} | Remédio Fácil`
    }
  },
  {
    name: 'unidades-remedio',
    path: '/remedio-facil/unidades/:principio',
    component: Unidades,
    meta: {
      title: `${DEFAULT_TITLE} | Unidades com remédio`
    }
  },
  {
    name: 'detalhe-unidade',
    path: '/remedio-facil/unidade/:detalhes',
    component: DetalheUnidade,
    meta: {
      title: `${DEFAULT_TITLE} | Lista de remédios por unidade`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/remedios.js